import PropTypes from "prop-types";

import DeleteButton from "@/components/Header/Button/DeleteButton";
import InfoButton from "@/components/Header/Button/InfoButton";
import ProgressButton from "@/components/Header/Button/ProgressButton";
import HeaderButtonList from "@/components/Header/HeaderButtonList";
import { BUTTON_TYPE, BUTTON_KEYS } from "@/constants/Button";
import Info from "@/features/Projects/Info";
import ProjectEdit from "@/features/Projects/ProjectEdit";
import { useAuthorization } from "@/modules/authorization";
import { useSidePanel } from "@/modules/side-panel";
import { StateEditForm } from "@/modules/state-edit-form";
import { useIdParam } from "@/services/router";
import { EditButton } from "@/ui/edit-button";

const HeaderButtons = ({ project = {} }) => {
  const id = useIdParam();
  const { openSidePanel } = useSidePanel();
  const { canUpdate, canDelete } = useAuthorization();

  const onEditClick = () => {
    openSidePanel({
      title: project.name,
      component: <ProjectEdit projectId={project.id} />,
    });
  };

  const onInfoSelect = () => {
    openSidePanel({
      title: project.name,
      component: <Info project={project} />,
    });
  };

  const primaryActions = [];
  if (canUpdate(project)) {
    primaryActions.push(
      <StateEditForm
        key={BUTTON_KEYS.STATE_EDIT}
        stateType="project"
        model={project}
      />
    );
  }

  primaryActions.push(
    <ProgressButton
      key={BUTTON_KEYS.PROGRESS}
      type="project"
      model={project.id ? project : { ...project, id }}
      isEditable={false}
    />
  );

  primaryActions.push(<InfoButton key="info" onInfoSelect={onInfoSelect} />);

  const secondaryActions = [];

  if (canUpdate(project)) {
    secondaryActions.push({
      key: BUTTON_KEYS.EDIT,
      label: (
        <EditButton key={BUTTON_KEYS.EDIT} type="text" onClick={onEditClick} />
      ),
    });
  }

  if (canDelete(project)) {
    secondaryActions.push({
      key: BUTTON_KEYS.DELETE,
      label: (
        <DeleteButton
          key={BUTTON_KEYS.DELETE}
          modelKey="project"
          model={project}
          buttonProps={{
            type: BUTTON_TYPE.TEXT,
          }}
        />
      ),
    });
  }

  return (
    <HeaderButtonList
      primaryActions={primaryActions}
      secondaryActions={secondaryActions}
    />
  );
};

HeaderButtons.propTypes = {
  project: PropTypes.object.isRequired,
};

export default HeaderButtons;
